import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.261 20.392h4.65v-7.413h5.816v7.413h4.652V9.052l-7.56-5.716L4.26 9.053v11.339Zm-1.26 1.26V8.895a.947.947 0 0 1 .376-.755l7.87-5.948a.947.947 0 0 1 1.143 0l7.873 5.947a.949.949 0 0 1 .376.756v12.757h-7.173v-7.414h-3.293v7.414H3.001Z",
		fill: "currentColor"
	})
});
export default SvgHome;
